import AppCommonModal from "@/components/AppCommonModal";
import Image from "next/image";
import gaTracker from "@/ga";
import {APICapInvitation, APIGetUserInfo, APIRefreshCapStatus} from "@/api";
import { lightTips } from "@/pages/person-center";
import React, {useEffect, useMemo, useState} from "react";
import EligibleModal, {Eligible7DTipsModal} from "@/components/EligibleModal";
import {useSelector} from "react-redux";
import CommonLoading from "@/components/CommonLoading";
import useDispatchAction from "@/hooks/useDisptachAction";
import {setUserInfo} from "@/redux/actions/home";
import {useRouter} from "next/router";
import useLanguage from "@/hooks/useLanguage";
import useErrorMap from "@/hooks/useErrorMap";
import {Trans} from "react-i18next";
import {LoadingOutlined} from "@ant-design/icons";

const UnLockHighestCommissionModal = ({ show, onCancel, imgUrl, title, type, onSuccess, utmObtain }) => {
  const { t } = useLanguage();
  const [containLoading, setContainLoading] = useState(false);
  const [obtainLoading, setObtainLoading] = useState(false);
  const [eligibleModal, setEligibleModal] = useState(false);
  const [eligibleModal7Day, setEligibleModal7Day] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isObtain, setIsObtain] = useState(false);
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const router = useRouter();
  const { errCodeMap } = useErrorMap();
  const checkObtain = async () =>{
    gaTracker.trackEvent("profile_obtain", true);
    if (["/", "/product"].includes(router.pathname)){
      gaTracker.trackEvent(utmObtain, true);
    }
    try {
      setContainLoading(true);
      const res = await APICapInvitation({});
      setContainLoading(false);
      getUserInfo();
      if (res?.data?.result.isSucess === true){
        setEligibleModal(true);
        return;
      }

      if (res?.data?.result.isSucess === false){
        setEligibleModal7Day(true);
        let error = errCodeMap[res.data.result.code] ?? t('unlock_commission_modal.unknown_error');
        setErrorMsg(error);
        return;
      }

    } catch (e){
      console.log(e);
    }
    setContainLoading(false);
  };

  const reFreshCap = async () =>{
    gaTracker.trackEvent("profile_already", true);
    setObtainLoading(true);
    const res = await APIRefreshCapStatus({});
    setObtainLoading(false);
    setIsObtain(res.data.result);
    if (!res.data.result){
      setEligibleModal7Day(true);
      setErrorMsg(<div>
        {t('unlock_commission_modal.join_our')}
        { lightTips(t('unlock_commission_modal.creator_affiliate_program')) } {t('unlock_commission_modal.to_enjoy_highest_commission')}
        <span onClick={()=> {
          // setEligibleModal7Day(false);
          checkObtain();
        }} className={"high_light mx-1 font-bold cursor-pointer underline"}> {t('unlock_commission_modal.obtain_eligibility')} </span> {t('unlock_commission_modal.button_to_join_us')}
      </div>);
    } else {
      onSuccess?.();
      getUserInfo();
    }
  };

  const dispatchAction = useDispatchAction({ setUserInfo });

  const getUserInfo = () => {
    const token = localStorage.getItem("token");
    if (token) {
      APIGetUserInfo().then(resp => {
        if (resp.data.user) {
          const user = resp.data.user;
          dispatchAction.setUserInfo(user);
          localStorage.setItem("user", JSON.stringify(user));
        }
      });
    }
  };

  useEffect(()=>{
    setIsObtain(userInfo?.obtain);
  }, [userInfo]);

  const bodyContent = useMemo(() =>{
    if (eligibleModal || eligibleModal7Day) return <></>;
    if (type === 1) {
      return <AppCommonModal className={"zoom_1920"} width={561} title={""} show={show} onCancel={onCancel}>
        <div>
          <div className={"mt-[31px]"}>
            <div className={"mt-[22px] flex justify-center"}>
              <Image width={222} height={160} src={"/images/product/unlock-commission-icon.svg"} alt={""}></Image>
            </div>
            <div className={"text-color5 font-bold text-[16px]"}>
              {t('unlock_commission.title')}
            </div>
            <div className={"mt-[20px] mb-[15px] "}>
              <ol>
                <li className={"infoText mt-1"}>
                  • {t('unlock_commission_modal.ready_to_join')}
                  <span className={"infoTextDiff"}> {t('unlock_commission_modal.highest_commissions')}</span>
                  {t('unlock_commission_modal.on_every_product')}
                  <span className={"infoTextDiff"}> {t('unlock_commission_modal.offline_samples')} </span>,
                  Personalized <span className={"infoTextDiff"}> {t('unlock_commission_modal.one_on_one_support')} </span>, {t('unlock_commission_modal.and_tiktok_flash_sales')}
                </li>
                <li className={"infoText mt-1"}>
                  • {t('unlock_commission_modal.click_get_eligible')}
                  <span className={"infoTextDiff"}> {t('unlock_commission_modal.uango')} </span>
                  {t('unlock_commission_modal.to_your_tiktok')} <span className={"infoTextDiff"}> {t('unlock_commission_modal.accept_the_request')}</span>
                </li>
              </ol>
            </div>
            <div className={"flex mt-[58px] items-center justify-center gap-[26px]"}>
              <div onClick={()=>checkObtain()} className={"cursor-pointer trans-all hover:opacity-80 bg-linear text-white text-[14px] rounded-[25px] font-bold w-[219px] h-[44px] flex items-center justify-center"}>
                { containLoading && <CommonLoading className={"w-5 h-5"}></CommonLoading> }
                {t('unlock_commission.obtain')}
              </div>
              <div onClick={reFreshCap} className={"cursor-pointer bg-color1 trans-all hover:opacity-80 text-color2 text-[14px] rounded-[25px] w-[219px] h-[44px] flex items-center justify-center"}>
                { obtainLoading && <CommonLoading className={"w-5 h-5"}></CommonLoading>  }
                {t('unlock_commission.already')}
              </div>
            </div>
          </div>
        </div>
      </AppCommonModal>;
    }
    return <AppCommonModal className={"zoom_1920"} width={793} title={t('unlock_commission.sample_title')} show={show} onCancel={onCancel}>
      <div>
        <div className={"bg-color1 flex items-center gap-3 mt-[22px] px-3 py-2 rounded-[8px] text-[14px] leading-1.5"}>
          <img src={imgUrl} className={"w-20 h-20 rounded-[8px] shrink-0 object-cover"} />
          <div className={"text-color5 text-[14px] font-300"}>
            {title}
          </div>
        </div>

        <div className={"mt-[31px]"}>
          <div className={"text-color5 font-bold text-[16px]"}>{t('unlock_commission.sample_desc')}</div>
          <div className={"mt-[22px]"}>
            <Image width={694} height={209} src={"/images/product/free-sample-modal-des-icon.svg"} alt={""}></Image>
          </div>
          <div className={"flex mt-[58px] items-center justify-center gap-[26px]"}>
            <div onClick={()=>checkObtain()} className={"cursor-pointer trans-all hover:opacity-80 bg-linear text-white text-[14px] rounded-[25px] font-bold w-[219px] h-[44px] flex items-center justify-center"}>
              { containLoading && <CommonLoading className={"w-5 h-5"}></CommonLoading> }
              {t('unlock_commission.obtain')}
            </div>
            <div onClick={reFreshCap} className={"cursor-pointer bg-color1 trans-all hover:opacity-80 text-color2 text-[14px] rounded-[25px] w-[219px] h-[44px] flex items-center justify-center"}>
              { obtainLoading && <CommonLoading className={"w-5 h-5"}></CommonLoading>  }
              {t('unlock_commission.already')}
            </div>
          </div>
        </div>
      </div>
    </AppCommonModal>;
  }, [type, eligibleModal, eligibleModal7Day, obtainLoading, containLoading]);

  return <>
    {
      bodyContent
    }
    <EligibleModalSuccess show={eligibleModal} onCancel={() => {
      setEligibleModal(false);
      onCancel();
    }}></EligibleModalSuccess>
    <Eligible7DTipsModal content={errorMsg} show={eligibleModal7Day} onCancel={() => {
      setEligibleModal7Day(false);
      onCancel();
    }}></Eligible7DTipsModal>
  </>;
};

const EligibleModalSuccess = ({show, onCancel}) =>{
  const { t } = useLanguage();
  return <AppCommonModal className={"zoom_1920"} width={465} show={show} onCancel={onCancel}>
    <div className={"flex flex-col items-center mt-5"}>
      <Image width={50} height={48} src={"/images/success-tips-icon.svg"} alt={""}></Image>
      <div className={"text-[14px] leading-1.5 mt-7"}>
        {t('unlock_commission.success')}
      </div>
    </div>
  </AppCommonModal>;
};

export default UnLockHighestCommissionModal;
